// extracted by mini-css-extract-plugin
export var activeDot = "_8h-c";
export var buttonContainer = "_8h-9";
export var channelButton = "_8h-a";
export var clickable = "_8h-d";
export var content = "_8h-0";
export var contentFull = "_8h-2";
export var contentThird = "_8h-1";
export var contentWrapper = "_8h-7";
export var description = "_8h-5";
export var heightShort = "_8h-f";
export var image = "_8h-3";
export var imageContainer = "_8h-4";
export var selectButton = "_8h-e";
export var spinnerContainer = "_8h-b";
export var titleContent = "_8h-8";
export var titleWrapper = "_8h-6";